import { render, staticRenderFns } from "./ClientInfoTab.vue?vue&type=template&id=9ff8bdee&scoped=true&"
import script from "./ClientInfoTab.vue?vue&type=script&lang=js&"
export * from "./ClientInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientInfoTab.vue?vue&type=style&index=0&id=9ff8bdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff8bdee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VCol,VRow,VTextField})
